export default __webpack_public_path__ + "static/media/3.67154df0.jpg";